import { z } from 'zod';

/**
 * Shared base schema for all tool results. The backend adds `timestamp` to every
 * tool result via a hook, so we model it here so Zod preserves it during safeParse.
 * New tool result schemas should extend this via `BaseToolResultSchema.extend({...})`.
 */
export const BaseToolResultSchema = z.object({
  timestamp: z.string().optional(),
});
